import React from "react"
import { Container, Logo, Wrapper, CopytightContainer, TMDBLogo, SocialHandle, SocialLink, Text, CopyrightWrapper, Content, Item, Title, Body, Subtitle, FLink } from "./footer/footer"
import { Container as GridContainer } from "../../containers"
import { Icon } from "../../components"

export default function Footer({ children, ...rest }) {
  return (
    <Container {...rest}>
      <GridContainer>
        <Wrapper>{children}</Wrapper>
      </GridContainer>
    </Container>
  )
}

Footer.Logo = function FooterLogo() {
  return <Logo src="https://raw.githubusercontent.com/MajorCoding/Logos/main/footer-logo.svg" />
}

Footer.TMDBLogo = function FooterTMDBLogo() {
  return <TMDBLogo src="https://www.themoviedb.org/assets/2/v4/logos/v2/blue_square_2-d537fb228cf3ded904ef09b136fe3fec72548ebc1fea3fbbd1ad9e36364db38b.svg" />
}

Footer.Content = function FooterContent({ children, ...rest }) {
  return <Content {...rest}>{children}</Content>
}

Footer.Item = function FooterItem({ children, ...rest }) {
  return <Item {...rest}>{children}</Item>
}

Footer.Title = function FooterTitle({ children, ...rest }) {
  return <Title {...rest}>{children}</Title>
}

Footer.Body = function FooterBody({ children, ...rest }) {
  return <Body {...rest}>{children}</Body>
}

Footer.Subtitle = function FooterSubtitle({ children, ...rest }) {
  return <Subtitle {...rest}>{children}</Subtitle>
}

Footer.Text = function FooterText({ children, ...rest }) {
  return <Text {...rest}>{children}</Text>
}
Footer.FLink = function FooterFLink({ children, to, ...rest }) {
  return (
    <FLink {...rest} to={to}>
      {children}
    </FLink>
  )
}

Footer.Copyright = function FooterCopyright({ children, ...rest }) {
  return (
    <CopytightContainer {...rest}>
      <GridContainer>
        <CopyrightWrapper>{children}</CopyrightWrapper>
      </GridContainer>
    </CopytightContainer>
  )
}

Footer.SocialHandle = function SocialHandles() {
  return (
    <SocialHandle>
      <SocialLink to="/">
        <Icon name="ph-github-logo" size="20" />
      </SocialLink>
      <SocialLink to="/">
        <Icon name="ph-linkedin-logo" size="20" />
      </SocialLink>
      <SocialLink to="/">
        <Icon name="ph-instagram-logo" size="20" />
      </SocialLink>
    </SocialHandle>
  )
}
